import Linguist from "../../lib/JuiS/Linguist";

const getRegionName = (region) => {
    if (region) {
        try {
            return new Intl.DisplayNames(Linguist.getLanguage(), {type: "region"}).of(region);
        } catch (e) {
            console.error(region + " is not a valid region name");
            return region;
        }

    }
    return "None";
};

const countryCodes = [
    "AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ",
    "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT",
    "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR",
    "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER",
    "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL",
    "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID",
    "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI",
    "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV",
    "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS",
    "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR",
    "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY",
    "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL",
    "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK",
    "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC",
    "VE", "VG", "VI", "VN", "VU", "WF", "WS", "XI", "YE", "YT", "ZA", "ZM", "ZW"
];

const countryByCurrency = {SEK: "SE", NOK: "NO", DKK: "DK", GBP: "GB", USD: "US", CHF: "CH", PLN: "PL"};

/**
 * Best guess of an app's country when app.country is empty or is not an ISO code (old apps store "Finland"):
 * a valid code in the app's country, the region of the user's language (sv-FI -> FI), the currency's country,
 * and finally FI, which is what almost all existing apps use.
 */
const getDefaultCountry = (app) => {
    const country = app?.country;
    if (country && countryCodes.includes(country.toUpperCase())) {
        return country.toUpperCase();
    }
    const languageRegion = (Linguist.getLanguage() || "").split("-")[1];
    if (languageRegion && countryCodes.includes(languageRegion.toUpperCase())) {
        return languageRegion.toUpperCase();
    }
    return countryByCurrency[app?.currencyCode] || "FI";
};

export {getRegionName, countryCodes, getDefaultCountry};